import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changePlanColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangePlan } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "plan",
  "plan_id",
  "old_plan",
  "old_plan_id",
  "status",
  "last_updated",
];

const TelitChangePlanBatch = () => (
  <BatchDetail
    title="Telit Change Plan"
    apiGet={__getChangePlan}
    client={CLIENTS.telit}
    columnsFactory={changePlanColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_plan"
    retryOperation="change_plan"
    showTerminate
    showCheckStatus
    checkStatusOperation="change_plan"
    getRowPath={(row) => `/telit/change_plan/${row.id}`}
  />
);

export default TelitChangePlanBatch;
